import { useEffect, useRef } from "react";
import gsap from "gsap";

export default function Hero() {
  const containerRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      const lines = containerRef.current.querySelectorAll("[data-reveal]");

      gsap.set(lines, { yPercent: 110, willChange: "transform" });

      gsap.to(lines, {
        yPercent: 0,
        duration: 1.2,
        ease: "power3.out",
        stagger: 0.15,
        delay: 0.3,
      });

      // Fade in the subtitle and scroll hint
      gsap.fromTo(
        containerRef.current.querySelectorAll("[data-fade]"),
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 1, ease: "power3.out", delay: 1.2, stagger: 0.2 }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <section
      ref={containerRef}
      className="flex flex-col justify-between min-h-[calc(100vh-clamp(32px,6vw,80px))] px-6 py-8 md:px-12 md:py-12"
    >
      {/* Top bar */}
      <div data-fade className="flex justify-between items-center font-mono text-xs tracking-widest uppercase text-ink/50">
        <span>Sourcebench Labs © 2025</span>
        <span>Software Engineering</span>
      </div>

      {/* Main headline */}
      <div className="flex-1 flex flex-col justify-center -mt-12">
        <h1 className="font-serif font-black leading-[0.9] tracking-tight">
          <div className="overflow-hidden">
            <span data-reveal className="block text-[clamp(3rem,10vw,10rem)] md:ml-[-0.04em]">
              Source
            </span>
          </div>
          <div className="overflow-hidden md:ml-[10vw]">
            <span data-reveal className="block text-[clamp(3rem,10vw,10rem)] italic">
              bench
            </span>
          </div>
          <div className="overflow-hidden">
            <span data-reveal className="block text-[clamp(3rem,10vw,10rem)]">
              Labs
            </span>
          </div>
        </h1>

        <p data-fade className="mt-8 max-w-md font-sans text-base md:text-lg text-ink/60 leading-relaxed md:ml-[10vw]">
          Engineering fullstack web platforms and mobile applications for enterprise-scale businesses.
        </p>
      </div>

      {/* Scroll hint */}
      <div data-fade className="flex justify-between items-end font-mono text-xs tracking-widest uppercase text-ink/30">
        <span>Scroll to explore</span>
        <span>Based worldwide</span>
      </div>
    </section>
  );
}
